import { IConfig } from 'affiny-core/env';
import { DeepPartial } from 'affiny-core/types';

export type TEnv = DeepPartial<IConfig>;

export enum EHostLang {
  UK = 'co.uk',
  IE = 'ie',
  FR = 'fr',
  DE = 'de',
  IT = 'it',
  ES = 'es',
  NL = 'nl',
  NO = 'no',
  PT = 'pt',
  SE = 'se',
  FI = 'fi',
  DK = 'dk',
  BE = 'be',
  CH = 'ch',
}

export enum EBrand {
  AFF = 'affiny',
  MAF = 'meeticaffinity',
  PA = 'partner',
  MA = 'matchaffinity',
  LE = 'lexamore',
}

export enum EBrandCode {
  AFF = 'aff',
  MAF = 'maf',
  PA = 'pa',
  MA = 'ma',
  LE = 'le',
}

export enum EBrandTitle {
  aff = 'Affiny',
  maf = 'MeeticAffinity',
  le = 'Lexamore',
  pa = 'Partner',
  ma = 'MatchAffinity',
}

export enum EUrlEnv {
  PPROD = 'pprod',
  STAGING = 'recette',
  KUBERECETTE = 'kube.recette.ilius.io',
  LOCAL = 'local',
}
